const STEPS = {
    START: "START",
    LOGIN: "LOGIN",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
  };
  
  export default STEPS;
  